import styled from 'styled-components';

export const DropdownStyled = styled.div`
  display: flex;
  align-items: center;
  color: var(--v3-text-color);
  justify-content: space-between;
  background: var(--v3-black-1);
  padding: 8px 10px;
  margin-bottom: 4px;
  min-height: 40px;
  & > div {
    margin: 0 0 0 5px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
